import ormActions from '../orm/actions';
import { bickActions } from '../common';

import { pick, random } from 'lodash';

import { groupBy, mapValues } from 'lodash';
import uuid from 'uuid/v4';

import parseTcrr from './parseTcrr';
/* eslint-disable import/no-webpack-loader-syntax */
import tcrr from '!raw-loader!./data/tcrr_example_protocol.csv';

export const createTcrrExampleProtocol = dispatch => {
  const rows = parseTcrr(tcrr);

  const actions = bickActions(
    ormActions,
    ['protocol', 'athlete', 'declaration', 'attempt', 'decision'],
    dispatch,
  );

  const groupedRows = groupBy(rows, 'groupLetter');

  for (const [groupLetter, rows] of Object.entries(groupedRows)) {
    const protocolUuid = uuid();
    actions.protocol.create({
      uuid: protocolUuid,
      title: `TCRR Example Group ${groupLetter}`,
    });

    const allDeclarations = {};
    const allAttempts = {};
    const allDecisions = {};
    for (const row of rows) {
      const athlete = {
        uuid: row.name,
        protocol: protocolUuid,
        ...pick(row, 'startNumber', 'name'),
        bodyweight: Math.floor(random(40, 110, true) * 100) / 100,
      };
      actions.athlete.upsert(athlete);

      const declarations = mapValues(row.lifts, ({ attempts }, liftUuid) =>
        attempts.map(attempt => ({
          athlete: athlete.uuid,
          lift: liftUuid,
          attemptNumber: attempt.number,
          changeNumber: 0,
          weight: attempt.weight,
          sequenceNumber: attempt.sequenceNumber,
        })),
      );
      allDeclarations[athlete.uuid] = declarations;

      const attempts = mapValues(row.lifts, ({ attempts }, liftUuid) =>
        attempts.map(attempt => ({
          athlete: athlete.uuid,
          lift: liftUuid,
          number: attempt.number,
          weight: attempt.weight,
          sequenceNumber: attempt.sequenceNumber,
        })),
      );
      allAttempts[athlete.uuid] = attempts;

      const decisions = mapValues(row.lifts, ({ attempts }, liftUuid) =>
        attempts.map(attempt => ({
          attempt: [athlete.uuid, liftUuid, attempt.number],
          origin: 'referees',
          isGoodLift: attempt.isGoodLift,
          sequenceNumber: attempt.sequenceNumber,
        })),
      );

      allDecisions[athlete.primaryKey] = decisions;
    }

    const currentSequenceNumber = 0;

    for (const athleteDeclarations of Object.values(allDeclarations)) {
      for (const declarations of Object.values(athleteDeclarations)) {
        for (const declaration of declarations) {
          actions.declaration.create(declaration);

          if (declaration.sequenceNumber > currentSequenceNumber) break;
        }
      }
    }

    for (const athleteAttempts of Object.values(allAttempts)) {
      for (const attempts of Object.values(athleteAttempts)) {
        for (const attempt of attempts) {
          if (attempt.sequenceNumber > currentSequenceNumber) break;

          actions.attempt.create(attempt);
        }
      }
    }

    for (const athleteDecisions of Object.values(allDecisions)) {
      for (const decisions of Object.values(athleteDecisions)) {
        for (const decision of decisions) {
          if (decision.sequenceNumber > currentSequenceNumber) break;

          actions.decision.create(decision);
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/demo/index.js